import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Wapper } from "@/components/Layout";
import { getLocationParamer } from "@/utils/common";
// import { Player } from '@lottiefiles/react-lottie-player';
import Lottie from 'lottie-react';
import NetworkFinal from './svg/NetworkFinal.json'
import Success from './svg/Success.json'
import "./style.scss";

const NotificationOfApp = ({ title, type }) => {
    const { t } = useTranslation();
    const status = getLocationParamer("status");
    const maxAttempt = getLocationParamer("maxAttempt");
    const locked = getLocationParamer("locked");
    const curTitle = (status === 'fail' && type === 'change') ? 'LB_RESET_SUCCESS_TITLE1' : title;
    const appType = getLocationParamer("appType");

    const changeSuccess = () => {
        if (window?.ForgotPasswordJSBridge) {
            window?.ForgotPasswordJSBridge?.loginTrigger?.()
            // window?.ForgotPasswordJSBridge?.closeWebView()
        }
    }
    const handleSuccess = () => {
        if (window?.ForgotPasswordJSBridge) {
            status === 'fail' ? window?.ForgotPasswordJSBridge?.closeWebView?.() : changeSuccess()
        }
    }

    useEffect(() => {
        if (window?.ForgotPasswordJSBridge) {
            window?.ForgotPasswordJSBridge?.showBackButton?.(false)
            if (!(status === 'fail') && type === 'change') {
               window?.ForgotPasswordJSBridge?.logout?.()
            }
        }

    }, [])

    const renderTitle = () => {
        if (maxAttempt) {
            return t('LB_OTP_ERR_APP_100021')
        } else {
            return t(type === 'change' ? (status === 'fail' ? 'CHANGEPASSWORD_UNSUCCESSFUL' : 'LB_CHANGE_SUCCESS_TITLE_Sub') : (status === 'fail' ? 'LB_RESET_SUCCESS_UNSUCCESSFUL' : 'LB_RESET_SUCCESS_TITLE'))
        }
    }

    const renderDesc = () => {
         if (maxAttempt) {
            return t('LB_OTP_ERR_APP_MESSGE_100021')
        } else if (locked){
            return t('WCIP_COMMON_ERR021_ERROR', { code: 'ERR021' })
        }else {
            return t(status === 'fail' ? 'CHANGEPASSWORD_LATER' : 'LB_RESET_SUCCESS_DESC')
        }
    }

    return (
        <Wapper className={`notification-container ${appType}`} title={curTitle}>
            <div className="topInfo">
                <Lottie
                    className="Lottie"
                    animationData={status === 'fail' ? NetworkFinal : Success}
                    loop={true}
                />
                {/* <div className="img" /> */}
                <div className="title">{renderTitle()}</div>
                <div className="desc">{renderDesc()}</div>
            </div>
            <div className="bottomInfo">
                <div className="loginBtn" onClick={handleSuccess}>{t(maxAttempt ? 'LB_CLOSE' : status === 'fail' ? 'CHANGEPASSWORD_TRY' : 'LB_RESET_SUCCESS_BUTTON')}</div>
            </div>
        </Wapper>
    )
}

export default NotificationOfApp